import Contact from "../../entities/Contact/ui/Contact";

const ContactPage = () => {
    return ( 
        <main>
            <Contact/>
        </main>
     );
}
 
export default ContactPage;